"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = void 0;
const date_fns_1 = require("date-fns");
const strftime_1 = __importDefault(require("strftime"));
const chrono_1 = require("../chrono");
const unit_1 = require("../unit");
const value_1 = require("../value");
const w_now = (context) => {
    context.push((0, chrono_1.dateToTimeValue)(new Date()));
};
const w_hour = (context) => {
    context.pushNumber(context.peekTime().hour, unit_1.units.hour);
};
const w_minute = (context) => {
    context.pushNumber(context.peekTime().minute, unit_1.units.minute);
};
const w_second = (context) => {
    context.pushNumber(context.peekTime().second, unit_1.units.second);
};
const w_format = (context) => {
    const date = (0, chrono_1.timeValueToDate)(context.popTime());
    const formatString = context.popString();
    context.pushString((0, strftime_1.default)(formatString, date));
};
const w_toNumber = (context) => {
    const time = context.popTime();
    let result = 0;
    result += time.hour * date_fns_1.secondsInHour;
    result += time.minute * date_fns_1.secondsInMinute;
    result += time.second;
    context.pushNumber(result, unit_1.units.second);
};
const w_toVector = (context) => {
    const time = context.popTime();
    context.pushVector([
        (0, value_1.newNumberValue)(time.hour, unit_1.units.hour),
        (0, value_1.newNumberValue)(time.minute, unit_1.units.minute),
        (0, value_1.newNumberValue)(time.second, unit_1.units.second),
    ]);
};
exports.time = [
    ["now", w_now],
    ["time:hour", w_hour],
    ["time:minute", w_minute],
    ["time:second", w_second],
    ["time:format", w_format],
    ["time:>number", w_toNumber],
    ["time:>vector", w_toVector],
];
